import { Box, Pagination, Typography } from "@mui/material";
import { useState, useEffect } from "react";
import { useAppDispatch, useAppSelector, RootState } from "../../../store";
import InputForm from "../forms/inputForm";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import SelectForm from "../forms/selectFormm";
import { useSearchParams, useLocation } from "react-router-dom";
import { getBodyTable } from "../../../store/feature/form";

// pagination for form dynamic

const PaginationDynamic = ({ params, setParams, page_access_uid }: any) => {
  const dispatch = useAppDispatch();
  const [searchParams] = useSearchParams();
  const { totalRecForm } = useAppSelector((store: RootState) => store.form);
  const [page, setPage] = useState(1);
  const [pagesize, setPagesize] = useState(10);
  const idPath = searchParams.get("form-type-uid");
  const { pathname } = useLocation();

  useEffect(() => {
    setPage(1);
  }, [pathname]);

  const schema = yup.object({
    goTo: yup.number().required(),
  });
  const {
    control,
    formState: { errors },
  } = useForm<{
    goTo: number;
  }>({
    reValidateMode: "onChange",
    resolver: yupResolver(schema),
    defaultValues: {
      goTo: 0,
    },
  });

  const handlePerPage = (e: any) => {
    setPagesize(e.value);
  };

  useEffect(() => {
    if (page_access_uid.length !== 0){
    let tempPage = page;
    const totalPage = calculateTotalPage();
    if (totalPage < page) {
      tempPage = totalPage;
    }
    let tempParams = {
      ...params,
      page: tempPage,
      pagesize,
    };
    setParams(tempParams);
    if(
      page_access_uid != "" && 
      page_access_uid != undefined && 
      page_access_uid != null
    ) {
      const param = {
        id: idPath,
        params: tempParams,
        page_access_uid: page_access_uid
      };
      dispatch(getBodyTable(param))
    };
  }
  }, [page, pagesize]);

  const handlePaginate = (newPage: any) => {
    setPage(newPage);
  };

  const calculateTotalPage = () => {
    return Math.ceil(totalRecForm/ pagesize);
  };

  const handlePageGoto = (e: any) => {
    if (e === "" || e === undefined) {
      setPage(1);
      return;
    }
    setPage(e);
  };
  const optSelect = [
    {
      label: "10/page",
      value: 10,
    },
    {
      label: "20/page",
      value: 20,
    },
    {
      label: "30/page",
      value: 30,
    },
    {
      label: "50/page",
      value: 50,
    },
    {
      label: "100/page",
      value: 100,
    },
  ];

  return (
    <Box
      sx={{
        flexDirection: "row",
        paddingY: "13px",
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        paddingRight: "20px",
        gap: 3,
      }}
    >
      <Box
        sx={{
          display: "flex",
          gap: 1,
          alignItems: "center",
          justifyContent: "center",
          width: "170px",
          // paddingTop: "10px",
        }}
      >
        <Typography
          variant="paragraph1"
          // fontFamily="open sans"
          mt= '10px'
        >
          Total {totalRecForm}
        </Typography>
        <SelectForm
          name="perPage"
          defaultValue={1}
          options={optSelect}
          placeholder="10/page"
          disabled={false}
          isLoading={false}
          control={control}
          errors={errors}
          required
          onChangeForm={handlePerPage}
        />
      </Box>

      <Pagination
        count={calculateTotalPage()}
        variant="outlined"
        shape="rounded"
        onChange={(event, newPage) => handlePaginate(newPage)}
        sx={{mt: 2}}
        page={page}
      />
      <Box
        sx={{
          display: "flex",
          gap: 1,
          alignItems: "center",
          justifyContent: "center",
          width: "100px",
        }}
      >
        <Typography variant="body1" mt="10px">
          Go to
        </Typography>
        <InputForm
          onChange={handlePageGoto}
          name="goTo"
          required
          maxLength={3}
          control={control}
          disabled={false}
          errors={errors}
          isLoading={false}
          sxFL={{ color: "red", backgroundColor: "red" }}
          endAdornment={<Typography variant="body16Regular"></Typography>}
          sxEndAdornment={{ backgroundColor: "red" }}
        />
      </Box>
    </Box>
  );
};

export default PaginationDynamic;
